// extracted by mini-css-extract-plugin
export default {"messagesMainContainer":"Messages_messagesMainContainer__4zd9N"};